import { Helmet } from "react-helmet-async";
// @mui
import { Grid, Button, Container, Stack, Typography } from "@mui/material";

// ----------------------------------------------------------------------

export default function StatsPage() {
  window.location.href = `/stats/stats.html?apiUrl=${process.env.REACT_APP_API_BASE_URL}`;
  return (
    <>
      <Helmet>
        <title> Dashboard:Stats </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Stats
          </Typography>
        </Stack>
      </Container>
    </>
  );
}
